import type { ApiPlayable } from "@hive/sdk";

export type CatalogueOrder = "featured" | "hot" | "latest";
export function catalogueOrder(value: unknown): CatalogueOrder {
	return value === "hot" || value === "latest" ? value : "featured";
}

/** Manual CMS collections have a finite membership; sorting never adds unrelated games. */
export function sortCatalogue<T>(items: T[], order: CatalogueOrder, playable: (item: T) => ApiPlayable): T[] {
	if (order === "featured") return items;
	const date = (item: ApiPlayable) => {
		const value = Date.parse(item.publishedAt ?? item.createdAt ?? "");
		return Number.isFinite(value) ? value : 0;
	};
	return items.map((item, index) => ({ item, index })).sort((a, b) => {
		const first = playable(a.item), second = playable(b.item);
		return (order === "hot" ? (second.playCount ?? 0) - (first.playCount ?? 0) : date(second) - date(first)) || a.index - b.index;
	}).map(({ item }) => item);
}
